import axios from 'axios';
import { adminMainUrl } from '../../../Config';

//unused final Quotation with Pagination List
export const getUnpickedJobOrderWithExpenseList = (token, user_id, page, identifier, impexp, airsea, queryString) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/unpicked-job-order-with-expenses`;
        if (identifier == "picked-joborder") {
            apiUrl = `${adminMainUrl}/api/account/picked-job-order-with-expenses`;
        } else if (identifier == "unpicked-joborder") {
            apiUrl = `${adminMainUrl}/api/account/unpicked-job-order-with-expenses`;
        }
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        // if (search_text) queryParams.push(`search=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        let body = {
            airsea: airsea == "sea" ? "ocean" : "air",
            impexp: impexp == "import" ? "IMPORTER" : "EXPORTER",
            page: page ?? 1
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getUnpickedJobOrderWithExpenseList function (redux):", err);
                dispatch({
                    type: "FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getUnpickedJobOrderWithExpenseList function:", error);
            dispatch({
                type: "FIND_UNPICKED_JOB_ORDER_WITH_EXPENSE_FAILURE",
                payload: error,
            });
        }
    };
};

//view job order details
export const getJobOrderAccountExpenseDetails = (token, user_id, job_order_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/view-job-order`;

        let body = {
            job_order_id: job_order_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getJobOrderAccountExpenseDetails function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderAccountExpenseDetails function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_JOB_ORDER_ACCOUNT_EXPENSE_FAILURE",
                payload: errmsg,
            });
        }
    };
};

//view expense details
export const getExpenseDetails = (token, user_id, expense_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_EXPENSE_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/view-expense`;

        let body = {
            expense_id: expense_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_EXPENSE_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getExpenseDetails function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_EXPENSE_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getExpenseDetails function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_EXPENSE_FAILURE",
                payload: errmsg,
            });
        }
    };
};

//view expense remarks
export const getExpenseRemarks = (token, user_id, expense_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_EXPENSE_REMARKS_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/get-remarks`;

        let body = {
            expense_id: expense_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_EXPENSE_REMARKS_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getExpenseRemarks function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_EXPENSE_REMARKS_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getExpenseRemarks function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_EXPENSE_REMARKS_FAILURE",
                payload: errmsg,
            });
        }
    };
};